<template>
  <div>
    <button
      class="d-none"
      data-toggle="modal"
      data-target="#Teams"
      ref="openModalTeams"
    ></button>
    <div class="modal fade" tabindex="-1" role="dialog" id="Teams">
      <div
        class="modal-dialog modal-dialog-centered teammates-lineup-modal"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title m-0 text-capitalize">
              Manage Teams - Men’s 65/70+ Silver Division
            </h6>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              ref="closeLineUpModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="teammates-lineup-wrapper">
              <div class="available-teammates">
                <h6>Available Teams</h6>
                <div class="teammates-info">
                  <draggable
                    class="list-group"
                    :list="availableTeams"
                    group="people"
                    @change="handleTeammateDrag"
                    v-if="showLoaderAvailableTeams == 0"
                  >
                    <div
                      class="list-group-item"
                      v-for="(element, index) in availableTeams"
                      :key="index"
                    >
                      <div class="teams-wrapper">
                        <h6 class="name">KC Classics</h6>
                        <p>65 Older - Major +</p>
                      </div>
                      <div>
                        <img
                          src="../../../assets/images/line-ellipsis.png"
                          alt=""
                        />
                      </div>
                    </div>
                  </draggable>
                  <div
                    class="no-line-up"
                    v-if="
                      showLoaderAvailableTeams == 0 &&
                      availableTeams.length == 0
                    "
                  >
                    <div class="img">
                      <img src="../../../assets/images/teammates.png" alt="" />
                    </div>
                    <p class="text">No Available Teams found.</p>
                  </div>
                  <div
                    class="lds-dual-ring-media"
                    v-if="showLoaderAvailableTeams == 1"
                  ></div>
                </div>
              </div>
              <div class="team-lineup">
                <h6>Selected Teams</h6>
                <div class="teammates-info position-relative">
                  <draggable
                    class="list-group"
                    :list="selectedTeams"
                    group="people"
                    @change="log()"
                    v-if="showLoaderSelectedTeams == 0"
                  >
                    <div
                      class="list-group-item"
                      v-for="element in selectedTeams"
                      :key="element"
                    >
                      <div class="teams-wrapper">
                        <h6 class="name">KC Classics</h6>
                        <p>65 Older - Major +</p>
                      </div>
                      <div>
                        <img
                          src="../../../assets/images/line-ellipsis.png"
                          alt=""
                        />
                      </div>
                    </div>
                  </draggable>
                  <div
                    class="no-line-up"
                    v-if="
                      showLoaderSelectedTeams == 0 && selectedTeams.length == 0
                    "
                  >
                    <div class="img">
                      <img src="../../../assets/images/teammates.png" alt="" />
                    </div>
                    <p class="text">No selected teams found.</p>
                  </div>
                  <div
                    class="lds-dual-ring-media"
                    v-if="showLoaderSelectedTeams == 1"
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div class="event-btns-wrapper p-3 justify-content-end">
            <button
              v-if="this.isDisabled == false"
              type="button"
              class="btn btn-primary w-25"
              v-on:click="saveTeams(0)"
              :disabled="isLoadingArray[0]"
            >
              <div v-if="isLoadingArray[0]" class="lds-dual-ring"></div>
              <span v-else>Save</span>
            </button>
            <button
              v-else-if="this.isDisabled == true"
              type="button"
              class="btn btn-primary-disabled w-25"
              :disabled="(true, isLoadingArray[0])"
            >
              <div v-if="isLoadingArray[0]" class="lds-dual-ring"></div>
              <span v-else>Save</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import draggable from "vuedraggable";
export default {
  name: "TournamentTeamsModal",
  data: function () {
    return {
      availableTeams: [],
      selectedTeams: [],
      isDisabled: true,
      isLoadingArray: [],
      showLoaderSelectedTeams: 1,
      showLoaderAvailableTeams: 1,
    };
  },
  components: {
    draggable,
  },
  methods: {
    log: function () {
      console.log("1");
    },
  },
  mounted() {
    this.$root.$on("openTournamentTeamsModal", () => {
      var elem = this.$refs.openModalTeams;
      if (elem) {
        elem.click();
      }
    });
  },
};
</script>